<script setup lang="ts">
defineProps<{
    message: string;
}>();
</script>

<template>
    <p class="alert alert-warning hideAfter provider-warning-banner">
        {{ message }}
    </p>
</template>

<style scoped>
.provider-warning-banner {
    margin-bottom: 12px;
    border-radius: 8px;
}
</style>
